const GetCastRoleNames = data => {
  const castenname = casten => {
    if (casten) {
      return casten
    }

    return ''
  }

  const { castenTemp, castarray, CastTeTemp, castCharacterEnTemp, castcharteTemp, updatedCastRoles } = data

  castenTemp.map((castenElement, index) => {
    const indexOfEnElement = castarray.findIndex(
      castElementobject => castElementobject.name_En === castenElement,
    )

    let personObject = {}
    if (indexOfEnElement > -1) {
      personObject = {
        PK: castarray[indexOfEnElement].PK,
        SK: castarray[indexOfEnElement].SK,
        personUUID: castarray[indexOfEnElement].personUUID,
        name_En: castenname(castenTemp[index]),
        name_Te: castenname(CastTeTemp[index]),
        roleName_En: castCharacterEnTemp[index] ? `as ${castCharacterEnTemp[index]}` : '',
        roleName_Te: castcharteTemp[index] ? `${castcharteTemp[index]}` : '',
        posterURL: castarray[indexOfEnElement].posterURL,
      }
      if (
        Object.keys(castarray[indexOfEnElement]).some(
          key => key === 'GSIPersonStatusAndPersonID',
        ) === true
      ) {
        personObject.personID = castarray[indexOfEnElement].personID
        personObject.role = `${castenElement} ${
          castCharacterEnTemp[index] ? 'as' : ''
        } ${castenname(castCharacterEnTemp[index])}`
        personObject.isAnonymous = castarray[indexOfEnElement].isAnonymous
        personObject.posterURL = castarray[indexOfEnElement].posterURL
        personObject.GSIPersonStatusAndPersonID =
          castarray[indexOfEnElement].GSIPersonStatusAndPersonID
          personObject.posterURL = castarray[indexOfEnElement].posterURL
      } else if (
        Object.keys(castarray[indexOfEnElement]).some(key => key === 'personID') === true
      ) {
        personObject.newPerson = true
        personObject.PK = castarray[indexOfEnElement].PK
        personObject.SK = castarray[indexOfEnElement].SK
        personObject.personID = castarray[indexOfEnElement].personID
          ? castarray[indexOfEnElement].personID
          : castarray[indexOfEnElement].PK
        personObject.personUUID = castarray[indexOfEnElement].personUUID
        personObject.name_En = castenname(castenTemp[index])
        personObject.name_Te = castenname(CastTeTemp[index])
        personObject.role = `${castenElement} ${
          castCharacterEnTemp[index] ? 'as' : ''
        } ${castenname(castCharacterEnTemp[index])}`
        personObject.roleName_En = castCharacterEnTemp[index]
          ? `as ${castCharacterEnTemp[index]}`
          : ''
        personObject.roleName_Te = castcharteTemp[index] ? `${castcharteTemp[index]}` : ''
        personObject.posterURL = castarray[indexOfEnElement].posterURL
      } else {
        personObject.newPerson = true
        personObject.personID = castarray[indexOfEnElement].personID
          ? castarray[indexOfEnElement].personID
          : castarray[indexOfEnElement].PK
        personObject.name_En = castenname(castenTemp[index])
        personObject.name_Te = castenname(CastTeTemp[index])
        personObject.role = `${
          castarray[indexOfEnElement].name_En ? castarray[indexOfEnElement].name_En : ''
        } ${castCharacterEnTemp[index] ? 'as' : ''} ${
          castCharacterEnTemp[index] ? castCharacterEnTemp[index] : ''
        }`
        personObject.posterURL = castarray[indexOfEnElement].posterURL
      }
    } else {
      personObject = {
        newPerson: true,
        name_En: castenname(castenTemp[index]),
        name_Te: castenname(CastTeTemp[index]),
        role: `${castenElement ? castenElement : ''} ${castCharacterEnTemp[index] ? 'as' : ''} ${
          castCharacterEnTemp[index] ? castCharacterEnTemp[index] : ''
        }`,
        roleName_En: castCharacterEnTemp[index] ? `as ${castCharacterEnTemp[index]}` : '',
        roleName_Te: castcharteTemp[index] ? `${castcharteTemp[index]}` : '',
        isAnonymous: true,
      }
    }

    updatedCastRoles.push(personObject)
    return castenElement
  })
  return updatedCastRoles
}

export default GetCastRoleNames
